
const data = [
    {
        id: 1,
        link: '#',
        title: 'Home',
    },
    {
        id: 2,
        link: '#about',
        title: 'About',
    },
    {
        id: 3,
        link: '#experience',
        title: 'Skills',
    },
    {
        id: 3,
        link: '#projects',
        title: 'Projects',
    },
    {
        id: 4,
        link: '#contact',
        title: 'Contact',
    }
]


export default data;
